<template>
    <div class="container-fluid">
        <h1>{{$t('components.search.title')}}</h1>
        <div class="row">
            <div class="col-sm-12">
                <ul class="nav justify-content-center ">
                    <li class="nav-item border-right">
                        <a class="nav-link" href="javascript:void(0)" @click="scrollToDiv('search-products')">
                            {{$t('components.products.title')}}
                            <span v-if="isLoading('products')"><i class="fa fa-spinner fa-spin text-wellis-gold"></i></span>
                            <span v-else :class="[result.products.length > 0 ? 'text-wellis-gold' : '']">({{result.products.length}})</span>
                        </a>
                    </li>
                    <li class="nav-item border-right" v-if="$store.getters['configStore/getStocklistModuleStatus']">
                        <a class="nav-link" href="javascript:void(0)" @click="scrollToDiv('search-stocklist')">
                            {{$t('components.stocklist.title')}}
                            <span v-if="isLoading('stocklist')"><i class="fa fa-spinner fa-spin text-wellis-gold"></i></span>
                            <span v-else :class="[result.stocklist.length > 0 ? 'text-wellis-gold' : '']">({{result.stocklist.length}})</span>
                        </a>
                    </li>
                    <li class="nav-item border-right" v-if="$store.getters['authStore/fromUSA']">
                        <a class="nav-link" href="javascript:void(0)" @click="scrollToDiv('search-stocklist-transit')">
                            {{`${$t('components.stocklist.title')} ${$t('components.stocklist-transit.title')}`}}
                            <span v-if="isLoading('stocklist')"><i class="fa fa-spinner fa-spin text-wellis-gold"></i></span>
                            <span v-else :class="[result.stocklistTransit.length > 0 ? 'text-wellis-gold' : '']">({{result.stocklistTransit.length}})</span>
                        </a>
                    </li>
                    <li class="nav-item border-right" v-if="!$store.getters['authStore/fromUSA'] && $store.getters['configStore/getShopOrdModuleStatus']">
                        <a class="nav-link" href="javascript:void(0)" @click="scrollToDiv('search-under-production')">
                            {{$t('components.shopord.title')}}
                            <span v-if="isLoading('shopord')"><i class="fa fa-spinner fa-spin text-wellis-gold"></i></span>
                            <span v-else :class="[result.shopord.length > 0 ? 'text-wellis-gold' : '']">({{result.shopord.length}})</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="javascript:void(0)" @click="scrollToDiv('search-news')">
                            {{$t('components.news.title')}}
                            <span v-if="isLoading('news')"><i class="fa fa-spinner fa-spin text-wellis-gold"></i></span>
                            <span v-else :class="[result.news.length > 0 ? 'text-wellis-gold' : '']">({{result.news.length}})</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row mt-5" id="search-products">
            <div class="col-sm-12">
                <h2>{{$t('components.products.title')}}</h2>
                <div class="card card-body shadow">
                    <div v-if="isLoading('products')" class="text-center">
                        <div class="spinner-border text-wellis-gold"></div>
                    </div>
                    <div v-else>
                        <div class="row" v-if="result.products.length > 0">
                            <div class="col-sm-12 p-0 d-flex col-lg-3" v-for="(product, index) in result.products" :key="index">
                                <ProductCard :product="product"/>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-sm-12">
                                <p>{{$t('components.products.offers.notfound')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5" id="search-stocklist" v-if="$store.getters['configStore/getStocklistModuleStatus']">
            <div class="col-sm-12">
                <h2>{{$t('components.stocklist.title')}}</h2>
                <div class="card card-body shadow">
                    <div v-if="isLoading('stocklist')" class="text-center">
                        <div class="spinner-border text-wellis-gold"></div>
                    </div>
                    <div v-else>
                        <StockFifoOffers :offers="result.stocklist" :has-price="$store.getters['authStore/appSettings'].api.hasPrice"
                                         :name="true"
                                         :small="true"
                                         :btn-configurator="true"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5" v-if="$store.getters['authStore/fromUSA']" id="search-stocklist-transit">
            <div class="col-sm-12">
                <h2>{{`${$t('components.stocklist.title')} ${$t('components.stocklist-transit.title')}`}}</h2>
                <div class="card card-body shadow">
                    <div v-if="isLoading('stocklist')" class="text-center">
                        <div class="spinner-border text-wellis-gold"></div>
                    </div>
                    <div v-else>
                        <StocklistTransitTable :items="result.stocklistTransit"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5" v-if="!$store.getters['authStore/fromUSA'] && $store.getters['configStore/getShopOrdModuleStatus']" id="search-under-production">
            <div class="col-sm-12">
                <h2>{{$t('components.shopord.title')}}</h2>
                <div class="card card-body shadow">
                    <div v-if="isLoading('shopord')" class="text-center">
                        <div class="spinner-border text-wellis-gold"></div>
                    </div>
                    <div v-else>
                        <ShopOrdOffers :offers="result.shopord" :has-price="$store.getters['authStore/appSettings'].api.hasPrice" :name="true"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5" id="search-news">
            <div class="col-sm-12">
                <h2>{{$t('components.news.title')}}</h2>
                <div class="card card-body shadow">
                    <div v-if="isLoading('news')" class="text-center">
                        <div class="spinner-border text-wellis-gold"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductApiService from "../../../api/product.api";
    import {empty} from "../../../helpers";
    import ProductCard from "../ProductCard";
    import {EVENT_LANG_CHANGE, EVENT_SEARCH} from "../../../core/constants";
    import StocklistApiService from "../../../api/stocklist.api";
    import ShopOrdApiService from "../../../api/shopord.api";
    import ShopOrdOffers from "../ShopOrdOffers";
    import StockFifoOffers from "../StockFifoOffers";
    import StocklistTransitTable from "../StocklistTransitTable";

    export default {
        name: "Search",
        components: {StocklistTransitTable, StockFifoOffers, ShopOrdOffers, ProductCard},

        mounted() {
            if (!empty(this.$route.query.value)) {
                this.clear().then(() => this.search(this.$route.query.value));
            } else {
                return this.$router.push({name: 'app.start'});
            }

            this.$eventBus.$on(EVENT_SEARCH, (value) => {
                this.clear().then(() => this.search(value));
            });

            this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
                this.clear().then(() => this.search(this.$route.query.value));
            });
        },

        destroyed() {
            this.$eventBus.$off(EVENT_LANG_CHANGE);
        },

        data() {
            return {
                result: {
                    products: false,
                    stocklist: false,
                    stocklistTransit: false,
                    shopord: false,
                    news: false,
                }
            }
        },

        methods: {
            clear() {
                return new Promise(resolve => {
                    this.result = {
                        products: false,
                        stocklist: false,
                        stocklistTransit: false,
                        shopord: false,
                        news: false,
                    };
                    resolve();
                });
            },

            search(value) {
                ProductApiService.search(value).then(response => this.result.products = response.data.result);
                StocklistApiService.search(value).then(response => {
                    this.result.stocklist = Object.values(response.data.result.fifo);
                    this.result.stocklistTransit = response.data.result.transit;
                });
                if (!this.$store.getters["authStore/fromUSA"]) {
                    ShopOrdApiService.search(value).then(response => this.result.shopord = response.data.result)
                }
                this.result.news = [];
            },

            scrollToDiv(id) {
                let el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView();
                }
            }
        },

        computed: {
            isLoading() {
                return prop => {
                    return this.result[prop] === false;
                }
            }
        }
    }
</script>

<style scoped>

    .nav-item {
        padding: 0 20px;
        color: #b89453;
    }
</style>
